module.exports = __webpack_public_path__ + "static/scale-model-of-milwaukee-wisconsin-0e1ead294a5081b179d56399ec9291d1.png";